import type { ReactNode } from 'react';
import { RouteNotFound } from './route-not-found.js';

/// Tela sem permissão responde como endereço inexistente para não revelar capacidades ocultas.
export function GatedCompanyScreen({
  allowed,
  children,
}: {
  allowed: boolean;
  children: ReactNode;
}) {
  return allowed ? children : <RouteNotFound />;
}
